module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-con"
  }, [_c('div', {
    staticClass: "v-modal",
    class: {
      'modal-active': _vm.showModal
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "allmap"
    }
  }), _vm._v(" "), _c('topbar', {
    ref: "topbar",
    on: {
      "onGetUserlist": _vm.onGetUserlist,
      "loginSuccess": _vm.onLoginSuccess,
      "refreshUserMarker": _vm.onRefreshUserMarker,
      "drawTrail": _vm.drawTrail,
      "changeUpdateTrail": _vm.changeUpdateTrail
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.markerTitle,
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "custom-class": "map-dialog",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("这是一段信息")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.messageTitle,
      "visible": _vm.editDialogVisible,
      "size": "large",
      "custom-class": "edit-dialog map-dialog slideInDown",
      "modal": false,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "open": _vm.onOpenChatDialog
    }
  }, [_c('div', {
    staticClass: "chatbox"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('div', {
    staticClass: "chatfoot"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.msgInput),
      callback: function($$v) {
        _vm.msgInput = $$v
      },
      expression: "msgInput"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("发送")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54b90026","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map.vue
// module id = 208
// module chunks = 1